import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class WarpTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('WarpTypeReference');
  }
}
